import axios from 'axios'
import React, { useEffect, useState } from 'react'
import { config } from '../../function/config'
import { toast } from 'react-toastify'
import { FaUserCheck } from 'react-icons/fa'
import { useNavigate } from 'react-router-dom'
import AdminHeader from './AdminHeader'

export default function AssignedEnquiries() {
    const navigate = useNavigate()
    const token = localStorage.getItem('token')

    const [donEnq, setDonEnq] = useState([])
    const [telecaller, setTelecaller] = useState([])

    const [loading, setLoading] = useState(false)
    const [selectedTelecallers, setSelectedTelecallers] = useState('')

    const fetchDonaionEnquiries = async() => {
        try{
            const res = await axios.get(`${config.baseurl}get_assigned_donation_enquiries/`, {
                headers:{
                    'Content-Type':'application/json',
                    'Authorization':`Token ${token}`
                }
            })
            console.log('All Donaion Enquiries:', donEnq)

            if(res.status === 200){
                setDonEnq(res.data.data)
            }else{
                toast.error('Fails to fetch Donation Enquiries')
            }
        }catch(error){
            console.error('Error:', error.response?.data || error)

            const message =
                error.response?.data?.message ||
                error.response?.data?.error ||
                'Failed to fetch department'

            toast.error(message)
        }
    }

    const fetchTelecaller = async() => {
        try{
            const res = await axios.get(`${config.baseurl}get_all_telecaller/`, {
                headers:{
                    'Content-Type':'application/json',
                    'Authorization':`Token ${token}`
                }
            })
            console.log('All Staffs:', donEnq)

            if(res.status === 200){
                setTelecaller(res.data.data)
            }else{
                toast.error('Fails to fetch telecallers')
            }
        }catch(error){
            console.error('Error:', error.response?.data || error)

            const message =
                error.response?.data?.message ||
                error.response?.data?.error ||
                'Failed to fetch telecaller'

            toast.error(message)
        }
    }

    useEffect(() => {
        fetchDonaionEnquiries()
        fetchTelecaller()
    },[token])
    console.log('Telecaller:', telecaller)

    console.log('all donation enquiries:', donEnq)

  return (
    <div className='min-h-screen bg-gradient-to-br from-slate-50 via-blue-50 to-slate-100 ml-64 5xl:ml-0'>
      <AdminHeader/>

      <div className='max-w-7xl mx-auto px-6 pt-16 pb-6 items-center justify-between text-center'>
        <h1 className='mt-1 text-3xl font-bold'>
          ALL Donation Enquiries
        </h1>
        <p className="mt-2 text-sm text-slate-500">
          View and manage all donation enquiries in one place.
        </p>
      </div>

      <div className='overflow-x-auto overflow-y-auto max-h-[70vh]'>
        <table className='w-full table-auto'>
          <thead>
            <tr className='text-center border-b border-slate-300'>
              <th className='px-3 py-2 whitespace-nowrap'>No</th>
              <th className='px-3 py-2 whitespace-nowrap'>Name</th>
              <th className='px-3 py-2 whitespace-nowrap'>Email</th>
              <th className='px-3 py-2 whitespace-nowrap'>Phone Number</th>
              <th className='px-3 py-2 whitespace-nowrap'>Subject</th>
              <th className='px-3 py-2 whitespace-nowrap'>Message</th>
              <th className='px-3 py-2 whitespace-nowrap'>Telecaller</th>
            </tr>
          </thead>

          <tbody>
            {donEnq.length > 0 ? (
              donEnq.map((item, index) => (
                <tr
                  key={item.id}
                  className='text-center border-b border-b-slate-300 cursor-pointer'
                >
                  <td className='px-3 py-2 whitespace-nowrap'>{index + 1}</td>
                  <td className='px-3 py-2 whitespace-nowrap'>{item.name}</td>
                  <td className='px-3 py-2 whitespace-nowrap'>{item.email}</td>
                  <td className='px-3 py-2 whitespace-nowrap'>{item.phone}</td>
                  <td className='px-3 py-2 whitespace-nowrap'>{item.subject}</td>
                  <td className='px-3 py-2 whitespace-nowrap'>{item.message}</td>
                  <td className='px-3 py-2 whitespace-nowrap'>{item.telecaller_name}</td>                </tr>
              ))
            ) : (
              <tr>
                <td
                  colSpan={6}
                  className='text-center py-6'
                >
                  No Data Found
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  )
}
